import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientInfosComponent } from '../client-infos/client-infos.component';

// interfaces
import { Client } from '../interfaces/Client';
import { DataTableClient } from '../interfaces/DataTableClient';

// services
import { ClientsService } from '../services/clients.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './../services/auth.service';
import { ShopsService } from './../services/shops.service';
import { ProvidersService } from './../services/providers.service';

@Component({
selector: 'app-clients',
templateUrl: './clients.component.html',
styleUrls: ['./clients.component.scss'],
})
export class ClientsComponent implements OnInit {

	@BlockUI() blockUI: NgBlockUI;
	@ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;

	ColumnMode = ColumnMode;
	columns = [
        { prop: 'date_registered', name: 'Date <i class="fa fa-sort sort-icon"></i></span>'},
		{ prop: 'fullName', name: 'Nom <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'id', name: 'Identifiant <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'phone', name: 'Téléphone <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'email', name: 'Email <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'cp_city', name: 'CP Ville <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'orderProcessing', name: 'Commandes en cours <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'orderFinished', name: 'Commandes terminées <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'btn_show', name: 'Voir les informations' },
	];

	clients: Array<Client>;
	dataTableClient: Array<DataTableClient>;
	currentPage: number = 1;
	collectionSize: number;
	totalItems: number = 10;
	searchField: string = "";
	columnSearch: string = "name";
	start: number = 0;

	network;
	onTwoNetworks: boolean = false;
	selectedNetwork: string = 'MDM';
	role: string;
	id_org_internal: string;

	empty_msgFr = {
		'emptyMessage': ''
	  };

	constructor(
		private clientsService: ClientsService,
		private toastrService: ToastrService,
		private orderModalService: NgbModal,
		private translate: TranslateService,
		private authService: AuthService,
		private shopsService: ShopsService,
		private providersService: ProvidersService,
	) {
		translate.get('Aucune donnée disponible', {value: ''})
		.subscribe((res: string) => this.empty_msgFr.emptyMessage = res);
	}

	ngOnInit() {
		this.getRole();
	}

	ngAfterViewInit(): void {
		this.fixBrowserTooltip();
	}

	getRole(): void {
		this.blockUI.start('Loading');

		const token = localStorage.getItem('token');

		this.authService.decodeJWT(token).subscribe(
			(res) => {
				if (res.success){
					this.role = res.data.role;

					if (this.role === 'Shop') {
						this.blockUI.stop();
						this.getShopDetailById();
					}

					if (this.role === 'Provider') {
						this.blockUI.stop();
						this.getProviderDetailById();
					}

					if (this.role === 'Admin') {
						this.onTwoNetworks = true;
						this.blockUI.stop();
						this.getClients();
					}

				} else{
					this.blockUI.stop();
					this.toastrService.error('Une erreur s\'est produite');
				}
			},
			(error) => {
				this.blockUI.stop();
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}

	getShopDetailById() {
		this.blockUI.start('Loading');

		const token = localStorage.getItem('token');

		this.authService.decodeJWT(token).subscribe(
			(res: any) => {
				if (res.success){
					this.id_org_internal = res.data.id_org_internal;

					this.shopsService.getShopDetailById(this.id_org_internal).subscribe(
						(res) => {
							if (res.success) {

								this.network = res.data.network;

								if (this.network.includes('SM') && this.network.length === 1) {
									this.selectedNetwork = 'SM';
								}

								if(this.network.length === 2) {
									this.onTwoNetworks = true;
								}

								this.blockUI.stop();
								this.getClients();

							} else {
								this.blockUI.stop();
								if (res.errorSet.includes('ERROR_SERVER')) {
									this.toastrService.error('Une erreur serveur est survenue');
								}
							}
						},
						(error) => {
							this.blockUI.stop();
							this.toastrService.error('Une erreur s\'est produite');
						}
					);
				}
			},
			(error) => {
				this.blockUI.stop();
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}

	getProviderDetailById() {
		this.blockUI.start('Loading');

		const token = localStorage.getItem('token');

		this.authService.decodeJWT(token).subscribe(
			(res: any) => {
				if (res.success){
					this.id_org_internal = res.data.id_org_internal;
					this.providersService.getProviderDetailById(this.id_org_internal).subscribe(
						(res) => {
							if (res.success) {

								this.network = res.data.network;
								if (this.network.includes('SM') && this.network.length == 1) {
									this.selectedNetwork = 'SM';
								}

								if(this.network.length === 2) {
									this.onTwoNetworks = true;
								}

								this.blockUI.stop();
								this.getClients();

							} else {
								this.blockUI.stop();
								if (res.errorSet.includes('ERROR_SERVER')) {
								this.toastrService.error('Une erreur serveur est survenue');
								}
							}
						},
						(error) => {
							this.blockUI.stop();
							this.toastrService.error('Une erreur s\'est produite');
						}
					);
					// this.blockUI.stop();
				} else {
					this.blockUI.stop();
					if (res.errorSet.includes('InvalidRequest')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('TokenError')) {
						this.toastrService.error('Token non trouvé ou invalidé');
					}
				}
			},
			(error) => {
				this.blockUI.stop();
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}

	onSearchChange(value: any) {
		this.getClients();
	}

	resetSearch() {
		if (this.searchField) {
			this.searchField = "";
			this.getClients();
		}
	}

	onPageChange(currentPage: number) {
		this.start = currentPage * this.totalItems - this.totalItems;
		this.getClients();
	}

	showClientInfos(client: Client) {
		const modalRef = this.orderModalService.open(ClientInfosComponent);
		modalRef.componentInstance.client = client;
	}

	getClients() : void {
		this.blockUI.start('Loading');

		const request = {
			network: this.selectedNetwork,
			nbByPage: this.totalItems,
			start: this.start,
			search: {
				[this.columnSearch]: this.searchField
			},
            token: localStorage.getItem('token')
		}

		this.clientsService.getClients(request).subscribe(
			(res) => {
				if(res.success) {
					this.clients = res.data;
                    console.log(this.clients);
					this.collectionSize = this.searchField === "" ? res.nbClientTotal : res.nbClientFiltered;
					this.blockUI.stop();
					this.dataTableClient = this.setDataTableClient();
				} else {
					this.blockUI.stop();

					if (res.errorSet.includes('INVALID_PARAMS')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');
					} else {
						this.toastrService.error('Une erreur s\'est produite');
					}
				}
			},
			(error) => {
				this.blockUI.stop();
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}

	getClientsByNetwork(event): void {
		this.selectedNetwork = event.value;
		this.getClients();
	}

	setDataTableClient(): Array<DataTableClient> {
		let dataTable = JSON.parse(JSON.stringify(this.clients));

		for (let i = 0; i < dataTable.length; i++) {
			const client = dataTable[i];

			Object.defineProperty(client, 'fullName', {
				value: `${client["firstName"]} ${client["lastName"]}`
			});

			Object.defineProperty(client, 'cp_city', {
				value: `${client["postCode"]} ${client["city"]}`
			});

			delete client.firstName;
			delete client.lastName;
			delete client.postCode;
			delete client.city;
		}

		return dataTable
	}

	fixBrowserTooltip(): void {
		let headerTitle = document.querySelectorAll('.datatable-header-cell');

		headerTitle.forEach(element => {

			let title = element.getAttribute('title');
			element.setAttribute('title', title.replace('<i class="fa fa-sort sort-icon"></i></span>', ''));

		});

	}
}
